module.exports = __webpack_public_path__ + "img/ps-46.fa44a427.jpg";